module.exports = __webpack_public_path__ + "img/accessory_shirt_11.019ec4a5.svg";